module.exports = __webpack_public_path__ + "static/media/TAGELUS.6fe56d43.pdf";